import { Injectable, inject } from '@angular/core';
import { LoginOrSignup } from '@freelancer/login-signup';
import { ShareServiceHelper } from '@freelancer/share-helper';
import { ModalService } from '@freelancer/ui';
import { ModalSize } from '@freelancer/ui/modal';
import { UserAgent } from '@freelancer/user-agent';
import { RoleApi } from 'api-typings/common/common';

@Injectable({
  providedIn: 'root',
})
export class BusinessBuilderSignupService {
  private modalService = inject(ModalService);
  private shareServiceHelper = inject(ShareServiceHelper);
  private userAgent = inject(UserAgent);

  async showDialog(
    businessBuilderId: string,
    isInAppBrowser?: boolean,
  ): Promise<void> {
    await this.modalService
      .open('LoginSignupModal', {
        edgeToEdge: true,
        mobileFullscreen: true,
        inputs: {
          form: LoginOrSignup.SIGNUP,
          signupHeader: $localize`Create an account`,
          skipSuccessRedirectView: true,
          forceAccountType: RoleApi.EMPLOYER,
          isInAppBrowser: isInAppBrowser ?? this.isInAppBrowser(),
          loginLink: this.shareServiceHelper.addBaseHref(
            `/business-builder?id=${businessBuilderId}`,
          ),
        },
        size: ModalSize.XSMALL,
      })
      .afterClosed();
  }

  private isInAppBrowser(): boolean {
    if (!this.userAgent.isMobileDevice()) {
      return false;
    }

    const ua = this.userAgent.getUserAgent().getUA();

    if (/Instagram/i.test(ua)) return true;
    if (/FBAN|FBAV/i.test(ua)) return true;
    if (/LinkedInApp/i.test(ua)) return true;
    if (/Reddit/i.test(ua)) return true;

    return false;
  }
}
